module.exports = __webpack_public_path__ + "media/images/homes/cash_mgt2x-4be446a9d45366104ed052a12610fe86.png";